<template src="./BookingEngineDetail.template.html"></template>
<script>
import moment from "moment-timezone";
import * as axios from "axios";
import VeeValidate from "vee-validate";
import Vue from "vue";
Vue.use(VeeValidate);
export default {
  name: "bookingEnginedetail",
  props: [],
  data() {
    return {
      //   series: [
      //   //   {
      //   //   name: "Sessions",
      //   //   data: []
      //   // }
      // ],
      //   chartOptions: {
      //     chart: {
      //       height: 350,
      //       zoom: {
      //         enabled: false
      //       }
      //     },
      //     dataLabels: {
      //       enabled: false
      //     },
      //     stroke: {
      //       curve: 'straight'
      //     },
      //     markers: {

      //       size: 6
      //     },
      //     title: {
      //       text: 'Google Analytics Report For Each Day',
      //       align: 'left'
      //     },
      //     grid: {
      //       row: {
      //         colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
      //         opacity: 0.5
      //       },
      //     },
      //     xaxis: {
      //       type: 'datetime',
      //       categories: [],

      //     }

      //   },
      //   showGraph: false,
      //   items: [

      //   ],
      apiUrl:
        window.location.protocol +
        "//" +
        window.location.hostname +
        (window.location.port ? ":1339" : ""),
      isBgColor1: true,
      isBgColor2: false,
      isBgColor3: false,
      isBgColor4: false,
      isBgColor5: false,
      isBgColor6: false,
      isBgColor7: false,
      isBgColor8: false,
      isBgColor9: false,
      isBgColor10: false,
      displaySectionValue: "DomainConfiguration",
      showDomainConfiguration: true,
      showHeaderConfiguration: true,
      showFooterConfiguration: true,
      showTermsAndConditionsConfiguration: true,
      // showmapConfiguration:false,
      showAsideLeftConfiguration: true,
      showAsideRightConfiguration: true,
      // showCssMaster: true,
      tldList: [],
      resStatusDropdown: [],
      be_Id: -1,
      // urlicon:false,
      beData: {
        BE_Name: "",
        BE_Description: "",
        TLD_Id: "",
        ResStatusId: "",
        SubDomainName: "",
        GuestPattern: "Persons",
        TermsAndConditions: null,
        BE_StatusId: 1,
        BE_Type: "Single Client",
        Zoom: "",
        MaxZoomValue: null,
        MinZoomValue: null,
        ChargesPattern: "Nightly",
        AccomodationPattern: "Accomodation",
        GACode: "",
        DepositPercent: "",
        Defaultsortorder: "-99"
      },
      // pageViews: "",
      // StartDate: "",
      // formattedStartDate: "",
      // formattedEndDate: "",
      // EndDate: "",
      latLogList: [],
      headerPreview: null,
      footerPreview: null,
      mapPreview: null,
      cssMaterPanel: true,
      csspanel: false,
      leftPreview: null,
      rightPreview: null,
      imageArr: [],
      showImageUpload: false,
      imageData: [],
      // HeaderHeightStyle: null,
      // FooterHeightStyle: null,
      disableHeaderInput: false,
      disableFooterInput: false,
      showleftConfig: true,
      showrightConfig: true,
      isCheckedleftConfig: false,
      isCheckedrightConfig: false,
      headerheightlist: [
        {
          name: "Auto",
          value: 1
        },
        {
          name: "px",
          value: 2
        },
        {
          name: "%",
          value: 3
        }
      ],
      AminitiesData: [],
      checkedAminities: [],
      locationList: [],
      sortOrderList: [],
      unitToggle: true,
      unitTypeToggle: true,
      propertyToggle: true,
      filteredPropertyList: [],
      filteredUnitTypeList: [],
      filteredUnitList: [],
      propertyLabel: {},
      unitLabel: {},
      propertyList: [],
      unitTypeList: [],
      unitList: [],
      filterSearchPropertyNameText: null,
      filterSearchUnitNameText: null,
      filterSearchUnitTypeNameText: null
    };
  },

  methods: {
    Get_BotDetails() {
      let vm = this;
      vm.$store.dispatch("dataRequestHandler", {
        key: "Get_BotDetails",
        params: {
          BotId: 8,
          BotType_Id: vm.beData.BotType_Id
        },
        callback: function (err, response) {
          if (err) {
            return;
          }
          if (response) {
            console.log("Get_BotDetails", response);
            if (response.recordsets[15] && response.recordsets[15].length && response.recordsets[15][0].UnitId && response.recordsets[15][0].UnitId == -1) {
              vm.unitToggle = true;
              if (vm.beData.IsHostMode != 1) {
                vm.unitLabel.UnitTypeName = "All Unit Types";
              }
              else {
                vm.unitLabel.UnitNickName = "All Units";
              }
            }
            else if (response.recordsets[15] && response.recordsets[15].length == 0) {
              vm.unitToggle = true;
              if (vm.beData.IsHostMode != 1) {
                vm.unitLabel.UnitTypeName = "All Unit Types";
              }
              else {
                vm.unitLabel.UnitNickName = "All Units";
              }
            }
            else {
              vm.unitToggle = false;
              if (vm.beData.IsHostMode != 1) {
                vm.unitLabel.UnitTypeName = "All Unit Types";
              }
              else {
                vm.unitLabel.UnitNickName = "All Units";
              }
            }
            if (response.recordsets && response.recordsets[16] && response.recordsets[16].length && response.recordsets[16][0].PropertyId && response.recordsets[16][0].PropertyId == -1) {
              vm.propertyToggle = true;
              vm.propertyLabel = response.recordsets[16][0];
            }
            else if (response.recordsets && response.recordsets[16] && response.recordsets[16].length == 0) {
              vm.propertyToggle = true;
              vm.propertyLabel.PropertyName = "All Properties"
            }
            else {
              vm.propertyToggle = false;
              vm.filteredPropertyList = response.recordsets[16];
            }
          }
        }
      });
    },
    addProperty(property) {
      let vm = this;
      vm.filteredPropertyList.push(property);
      var index = vm.propertyList.indexOf(property);
      console.log("index of Amenities=>", index);
      if (index > -1) {
        vm.propertyList.splice(index, 1);
        // console.log("scope.unitTypeList", vm.unitTypeList);
      }
      vm.getUnit_unitType_List();
    },
    addUnitType(unitType) {
      let vm = this;
      vm.filteredUnitTypeList.push(unitType);
      var index = vm.unitTypeList.indexOf(unitType);
      console.log("index of Amenities=>", index);
      if (index > -1) {
        vm.unitTypeList.splice(index, 1);
        // console.log("scope.unitTypeList", vm.unitTypeList);
      }
    },
    addUnit(unit) {
      let vm = this;
      vm.filteredUnitList.push(unit);
      var index = vm.unitList.indexOf(unit);
      console.log("index of Amenities=>", index);
      if (index > -1) {
        vm.unitList.splice(index, 1);
        console.log("scope.unitTypeList", vm.unitList);
      }
    },
    removeFilteredUnits(unit) {
      let vm = this;
      var index = vm.filteredUnitList.indexOf(unit);
      console.log("index of Amenities=>", index);
      if (index > -1) {
        vm.filteredUnitList.splice(index, 1);
        // console.log("scope.unitTypeList", vm.filteredUnitTypeList);
      }
      vm.unitList.push(unit);
    },
    removeFilteredUnitTypes(unitType) {
      let vm = this;
      var index = vm.filteredUnitTypeList.indexOf(unitType);
      console.log("index of Amenities=>", index);
      if (index > -1) {
        vm.filteredUnitTypeList.splice(index, 1);
        // console.log("scope.unitTypeList", vm.filteredUnitTypeList);
      }
      vm.unitTypeList.push(unitType);
    },
    removeFilteredProperty(property) {
      let vm = this;
      var index = vm.filteredPropertyList.indexOf(property);
      console.log("index============>", index);
      if (index > -1) {
        vm.filteredPropertyList.splice(index, 1);
      }
      vm.propertyList.push(property);
      console.log("scope.AmenitiesList after deleting", vm.propertyList);
      vm.getUnit_unitType_List();
    }, 
    showDropDown(filterCol) {
      let vm = this;
      setTimeout(function () {
        if (filterCol == 'property') {
          vm.getPropertiesBySearchText();
          $("#propertyDropdownlist").show();
        }
        if (filterCol == 'unitType') {
          vm.getUnitTypeList();
          $("#unitTypeDropdownlist").show();
        }
        if (filterCol == 'unit') {
          if (vm.beData.IsHostMode == 1) {
            vm.getUnitNamesBySearchText();
          } else {
            //vm.Get_UnitsAssociated_ToUnitType();
          }
          $("#unitDropdownlist").show();
        }
      }, 10);
    },
    getPropertiesBySearchText(searchText) {
      let vm = this;
      vm.$store.dispatch("dataRequestHandler", {
        key: "GetPropertiesBySearchText",
        params: {
          searchText: searchText
        },
        callback: function (err, response) {
          if (err) {
            return;
          }
          if (response) {
            vm.propertyList.splice(0, vm.propertyList.length, ...response.propertyList);
          }
          // vm.getReservationDetailById();
          for (var property of vm.filteredPropertyList) {
            let index = vm.propertyList.findIndex(
              x => x.PropertyId == property.PropertyId
            );
            if (index > -1) {
              vm.propertyList.splice(index, 1);
            }
          }
        }
      });
    },
    getUnit_unitType_List() {
      let vm = this;
      if (vm.beData.IsHostMode == 1) {
        vm.getUnitNamesBySearchText(null, "propertyChange");
      } else {
        vm.getUnitTypeList(null, "propertyChange")
      }
    },
    getUnitNamesBySearchText(searchText, changeName) {
      let vm = this;
      let propertyIds = (vm.filteredPropertyList && vm.filteredPropertyList.length && vm.filteredPropertyList[0].PropertyId) ? vm.filteredPropertyList.map(x => x.PropertyId) : []
      vm.$store.dispatch("dataRequestHandler", {
        key: "GetUnitListBySearchText",
        params: {
          searchText: searchText,
          PropertyId: propertyIds ? propertyIds.toString() : null,
        },
        callback: function (err, response) {
          if (err) {
            return;
          }
          if (response) {
            let List = response.unitList;
            if (changeName === "propertyChange") {
              if (propertyIds.length > 0) {
                vm.filteredUnitList.splice(0, vm.filteredUnitList.length, ...List);
              } else {
                vm.filteredUnitList.splice(0)
              }
            }
            for (var i = 0; i < vm.filteredUnitList.length; i++) {
              let index = List.findIndex(
                x => x.UnitId == vm.filteredUnitList[i].UnitId
              );
              if (index > -1) List.splice(index, 1);
              console.log("index", index);
            }
            vm.unitList.splice(0, vm.unitList.length, ...List);
            if (vm.filteredUnitTypeList.length > 0 || vm.filteredUnitList.length > 0) {
              vm.unitToggle = false;
            }
          }
        }
      });
    },
    getUnitTypeList(searchText, changeName) {
      let vm = this;
      let propertyIds = (vm.filteredPropertyList && vm.filteredPropertyList.length && vm.filteredPropertyList[0].PropertyId) ? vm.filteredPropertyList.map(x => x.PropertyId) : []
      vm.$store.dispatch("dataRequestHandler", {
        key: "Get_UnitTypeList",
        params: {
          sortBy: null,
          sortOrder: null,
          propertyId: propertyIds ? propertyIds.toString() : -1,
          statusId: 1,
          searchText: searchText,
          FromSetup: false
        },
        callback: function (err, response) {
          if (err) {
            return;
          }
          if (response) {
            console.log("Get_UnitTypeList==>", response);
            if (response[1] && response[1].length > 0) {
              vm.unitTypeList.splice(0, vm.unitTypeList.length, ...response[1]);
            }
            if (changeName === "propertyChange") {
              if (propertyIds.length > 0) {
                vm.filteredUnitTypeList.splice(0, vm.filteredUnitTypeList.length, ...vm.unitTypeList);
              }
              else {
                vm.filteredUnitTypeList.splice(0);
              }
            }
            console.log("vm.filteredUnitTypeList", vm.filteredUnitTypeList);
            for (var unitType of vm.filteredUnitTypeList) {
              let index = vm.unitTypeList.findIndex(
                x => x.UnitTypeId == unitType.UnitTypeId
              );
              if (index > -1) {
                vm.unitTypeList.splice(index, 1);
              }
            }
            if (vm.filteredUnitTypeList.length > 0 || vm.filteredUnitList.length > 0) {
              vm.unitToggle = false;
            }
          }
        }
      });
    },
    AmenitySave(e, Aminity) {
      if (e.target.checked) {
        return;
      } else {
        var index = this.AminitiesData.indexOf(Aminity);
        this.AminitiesData[index].IsChecked = 0;
        var index2 = this.AminitiesData.indexOf(Aminity.ListId);
        if (index2 > -1) {
          this.checkedAminities.splice(index2, 1);
        }
        console.log(
          "checked amineties========>",
          JSON.stringify(this.AminitiesData)
        );
        console.log("checkedAminities=>", this.checkedAminities);
      }
    },
    leftConfig() {
      let vm = this;
      if (vm.isCheckedleftConfig == true) {
        vm.showleftConfig = false;
      } else vm.showleftConfig = true;
    },
    rightConfig() {
      let vm = this;

      if (vm.isCheckedrightConfig == true) {
        vm.showrightConfig = false;
      } else vm.showrightConfig = true;
    },

    addImage() {
      let vm = this;
      vm.showImageUpload = true;
    },
    onChangeHeader(event) {
      let vm = this;
      console.log("event.target.value", event.target.value);
      if (event.target.value == "Auto") {
        vm.disableHeaderInput = true;
        vm.beData.HeaderHeight = "";
      } else vm.disableHeaderInput = false;
    },
    onChangeFooter(event) {
      let vm = this;
      console.log("event.target.value", event.target.value);
      if (event.target.value == "Auto") {
        vm.disableFooterInput = true;
        vm.beData.FooterText = "";
      } else vm.disableFooterInput = false;
    },
    imagePath(imageGuid, index) {
      let vm = this;
      console.log("imageGuid", index);
      let path = this.apiUrl + "/downloadImage/" + imageGuid + "/430x300";
      var myCode = path;
      var fullLink = document.createElement("input");
      document.body.appendChild(fullLink);
      fullLink.value = myCode;
      fullLink.select();
      document.execCommand("copy", false);
      fullLink.remove();
    },
    removeImage(imageGuid, index, isdelete) {
      console.log("imagesimages", imageGuid);
      let vm = this;
      // console.log("vm.imageArr[index]",vm.imageArr[index].ImageId);
      vm.$store.dispatch("dataRequestHandler", {
        key: "DeleteImages",
        params: {
          ModuleAction: "deleteImages",
          ImageId: vm.imageArr[index].ImageId,
          ImageUrl: vm.imageArr[index].ImageUrl,
          isdelete: isdelete
        },
        callback: function(err, response) {
          if (err) {
            console.error("Error has occured => ", err);
            vm.$store.dispatch("toastr", {
              type: "error",
              header: "error!",
              message: error.sqlMessage ? error.sqlMessage : err
            });
            return;
          } else if (response[0][0] && response[0][0].isEdited === true) {
            vm.$store.dispatch("toastr", {
              type: "success",
              header: "Success!",
              message: "successfully image updated"
            });
          } else {
            vm.$store.dispatch("toastr", {
              type: "success",
              header: "Success!",
              message: "successfully image deleted"
            });
          }
          // vm.getImages();
          vm.imageArr.splice(index, 1);
        }
      });
    },

    cancelImage(index, images) {
      let scope = this;
      // var index = scope.imageData.indexOf(images);
      console.log("cancelImage", index);
      // if (index >= -1) {
      scope.imageArr.splice(index, 1);
      scope.imageData = [];
      // }
    },

    uploadImages(e) {
      let vm = this;
      if (vm.$route.params.beId == -1) {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning",
          message: "Please save the DomainConfiguration"
        });
      } else {
        this.imageData = [];
        let files = e.target.files || e.dataTransfer.files;
        vm.path = files[0];
        console.log("vm.path", vm.path);
        this.imageData.push(files[0]);
        if (!files.length) {
          this.beData.unitImages = null; //upload images
          return;
        } else {
          this.createImage(files[0]);
        }
      }
    },

    // updateStartDate(key, dateObj) {
    //   let scope = this;
    //   scope.StartDate = dateObj ? dateObj.format("YYYY-MM-DD") : null;
    //   scope.formattedStartDate = dateObj
    //     ? dateObj.format("Do MMM YYYY")
    //     : null;
    // },

    // updateEndDate(key, dateObj) {
    //   let scope = this;
    //   scope.EndDate = dateObj ? dateObj.format("YYYY-MM-DD") : null;
    //   //console.log("updateEndDate")
    //   scope.formattedEndDate = dateObj
    //     ? dateObj.format("Do MMM YYYY")
    //     : null;
    // },

    createImage(file) {
      let reader = new FileReader();
      let vm = this;
      reader.onload = e => {
        // vm.image = e.target.result;
        // vm.propertyData.propertyContent.PropertyLogo = vm.image;

        // console.log("image===================>", vm.image);
        // vm.imageArr.push(vm.image);
        const formData = new FormData();
        Array.from(Array(this.imageData.length).keys()).map(x => {
          formData.append("photos", this.imageData[x], this.imageData[x].name);
        });
        console.log(this.apiUrl + "/upload");
        let url = this.apiUrl + "/upload";
        let obj = {};
        obj.ImageUrl = e.target.result;
        obj.ImageId = -1;

        vm.imageArr.push(obj);

        // console.log("base64" + vm.propertyImages);
        axios.post(url, formData).then(data => {
          console.log(data.data, data.data.length);
          // vm.imageArr.splice(-1, data.data.length);
          console.log("vm.imageArr.splice(-1, data.data.length);", vm.imageArr);
          vm.imageData.splice(0, vm.imageData.length);

          for (let img of data.data) {
            // vm.imageArr.push(apiUrl + '/downloadImage/'+img.imageGuid)
            let obj = {};
            obj.ImageUrl = img.imageGuid;
            obj.ImageId = -1;
            // vm.imageArr.splice(-1,1);
            //vm.imageArr.push(obj);
            vm.imageData.push(obj);
          }
          console.log("vm.imageArr", vm.imageArr);
          // vm.saveImages();
          // vm.saveMediaLibrary()
        });
      };
      reader.readAsDataURL(file);
    },

    saveMediaLibrary() {
      let vm = this;
      // vm.urlicon = true;
      console.log("vm.imageData===>", vm.imageData);
      vm.$store.dispatch("dataRequestHandler", {
        key: "saveAWS_Image",
        params: {
          ModuleAction: "saveAWS_Image",
          BE_Id: vm.$route.params.beId,
          // @ImageId INT,
          PropertyId: null,
          // @ClientId INT,
          images: vm.imageData,
          UnitId: null
          // @UserId INT = NULL,
        },
        callback: function(error, response) {
          if (error) {
            console.error("Error has occured => ", error);
            return;
          } else {
            vm.$store.dispatch("toastr", {
              type: "success",
              header: "Success!",
              message: "Images successfully saved"
            });
            vm.getImages();
            vm.imageData = [];
          }
        }
      });
    },
    getImages: function() {
      let scope = this;

      this.$store.dispatch("dataRequestHandler", {
        key: "GetImages",
        params: {
          ModuleAction: "GetImages",
          BE_Id: scope.$route.params.beId,
          UnitId: null,
          PropertyId: null
        },
        callback: function(err, response) {
          if (response) {
            console.log("response of get Images", response);
            if (response.recordsets[0] && response.recordsets[0] !== null) {
              scope.imageArr = response.recordsets[0];
            } else if (response.recordsets[0] === null) {
              scope.imageArr = [];
            }
          } else {
            console.log(err);
          }
        }
      });
    },
    imageURLS(imgGuid) {
      let isBase64 = /^data:image\/([a-zA-Z]*);base64,([^\"]*)/.test(imgGuid);
      if (isBase64) {
        return imgGuid;
      }
      return this.apiUrl + "/downloadImage/" + imgGuid + "/430x300";
    },
    displaySection(name) {
      let vm = this;
      vm.displaySectionValue = name;
      vm.cssMaterPanel = true;
      vm.csspanel = false;
      vm.showImageUpload = false;
      if (name === "DomainConfiguration") {
        vm.isBgColor1 = true;
        vm.isBgColor2 = false;
        vm.isBgColor3 = false;
        vm.isBgColor4 = false;
        vm.isBgColor5 = false;
        vm.isBgColor6 = false;
        vm.isBgColor7 = false;
        vm.isBgColor8 = false;
        vm.isBgColor9 = false;
        vm.isBgColor10 = false;
      }
      if (name === "HeaderConfiguration") {
        vm.isBgColor1 = false;
        vm.isBgColor2 = true;
        vm.isBgColor3 = false;
        vm.isBgColor4 = false;
        vm.isBgColor5 = false;
        vm.isBgColor6 = false;
        vm.isBgColor7 = false;
        vm.isBgColor8 = false;
        vm.isBgColor9 = false;
        vm.isBgColor10 = false;
      }
      if (name === "AsideLeftConfiguration") {
        vm.isBgColor1 = false;
        vm.isBgColor2 = false;
        vm.isBgColor3 = true;
        vm.isBgColor4 = false;
        vm.isBgColor5 = false;
        vm.isBgColor6 = false;
        vm.isBgColor7 = false;
        vm.isBgColor8 = false;
        vm.isBgColor9 = false;
        vm.isBgColor10 = false;
      }
      if (name === "AsideRightConfiguration") {
        vm.isBgColor1 = false;
        vm.isBgColor2 = false;
        vm.isBgColor3 = false;
        vm.isBgColor4 = true;
        vm.isBgColor5 = false;
        vm.isBgColor6 = false;
        vm.isBgColor7 = false;
        vm.isBgColor8 = false;
        vm.isBgColor9 = false;
        vm.isBgColor10 = false;
      }
      if (name === "FooterConfiguration") {
        vm.isBgColor1 = false;
        vm.isBgColor2 = false;
        vm.isBgColor3 = false;
        vm.isBgColor4 = false;
        vm.isBgColor5 = true;
        vm.isBgColor6 = false;
        vm.isBgColor7 = false;
        vm.isBgColor8 = false;
        vm.isBgColor9 = false;
        vm.isBgColor10 = false;
      }
      if (name === "CssMaster") {
        vm.isBgColor1 = false;
        vm.isBgColor2 = false;
        vm.isBgColor3 = false;
        vm.isBgColor4 = false;
        vm.isBgColor5 = false;
        vm.isBgColor6 = true;
        vm.isBgColor7 = false;
        vm.isBgColor8 = false;
        vm.isBgColor9 = false;
        vm.isBgColor10 = false;
      }
      if (name === "MediaLibrary") {
        vm.isBgColor1 = false;
        vm.isBgColor2 = false;
        vm.isBgColor3 = false;
        vm.isBgColor4 = false;
        vm.isBgColor5 = false;
        vm.isBgColor6 = false;
        vm.isBgColor7 = true;
        vm.isBgColor8 = false;
        vm.isBgColor9 = false;
        vm.isBgColor10 = false;
      }
      if (name === "Amenities") {
        vm.isBgColor1 = false;
        vm.isBgColor2 = false;
        vm.isBgColor3 = false;
        vm.isBgColor4 = false;
        vm.isBgColor5 = false;
        vm.isBgColor6 = false;
        vm.isBgColor7 = true;
        vm.isBgColor8 = false;
        vm.isBgColor9 = false;
        vm.isBgColor10 = true;
      }
      if (name === "TermsAndConditions") {
        vm.isBgColor1 = false;
        vm.isBgColor2 = false;
        vm.isBgColor3 = false;
        vm.isBgColor4 = false;
        vm.isBgColor5 = false;
        vm.isBgColor6 = false;
        vm.isBgColor7 = false;
        vm.isBgColor8 = true;
        vm.isBgColor9 = false;
        vm.isBgColor10 = false;
      }
      if (name === "Maps") {
        vm.isBgColor1 = false;
        vm.isBgColor2 = false;
        vm.isBgColor3 = false;
        vm.isBgColor4 = false;
        vm.isBgColor5 = false;
        vm.isBgColor6 = false;
        vm.isBgColor7 = false;
        vm.isBgColor8 = false;
        vm.isBgColor9 = true;
        vm.isBgColor10 = false;
      }
    },
    deleteDetails() {
      let vm = this;
      vm.beData.BE_Name = "";
      vm.beData.BE_Description = "";
      vm.beData.TLD_Id = "";
      vm.beData.SubDomainName = "";
      vm.beData.GuestPattern = "Persons";
      vm.beData.HeaderText = null;
      vm.beData.HeaderStyle = null;
      vm.beData.LeftViewText = null;
      vm.beData.LeftViewStyle = null;
      vm.beData.RightViewText = null;
      vm.beData.RightViewStyle = null;
      vm.beData.FooterText = null;
      vm.beData.FooterStyle = null;
      vm.beData.BEcss = "";
      vm.imageArr.splice(0, vm.imageArr.length);
      vm.Get_BookingEngine_Config();
    },
    // saveDomainConfiguration(StatusId, name) {
    //   let vm = this;
    //   vm.$store.dispatch("dataRequestHandler", {
    //     key: "Save_BEDomainSettings",
    //     params: {
    //       ModuleAction: "Save_BEDomainSettings",
    //       BE_Id: vm.$route.params.beId,
    //       BE_Name: vm.beData.BE_Name,
    //       BE_Description: vm.beData.BE_Description,
    //       GuestPattern: vm.beData.GuestPattern,
    //       TLD_Id: vm.beData.TLD_Id,
    //       SubDomainName: vm.beData.SubDomainName,
    //       StatusId: StatusId,
    //       sectionName: name,
    //       BE_Type: vm.beData.BE_Type,
    //       Header: vm.beData.HeaderText,
    //       Footer: vm.beData.FooterText,
    //       LeftView: vm.beData.LeftViewText,
    //       RightView: vm.beData.RightViewText,
    //       HeaderStyle: vm.beData.HeaderStyle,
    //       HeaderHeight: vm.beData.HeaderHeight,
    //       FooterHeight: vm.beData.FooterHeight,
    //       BeCss: vm.beData.BEcss,

    //       FooterStyle: vm.beData.FooterStyle,
    //       LeftViewCSS: vm.beData.LeftViewStyle,
    //       RightViewCSS: vm.beData.RightViewStyle,
    //       MaxZoomValue: vm.beData.MaxZoomValue,
    //       MinZoomValue: vm.beData.MinZoomValue,
    //       TermsAndConditions: vm.beData.TermsAndConditions

    //     },
    //     callback: function (err, response) {
    //       if (err) {
    //         console.log("Error in Save_BEDomainSettings => ", err);
    //         return;
    //       }

    //       if (response) {
    //         console.log("response in Save_BEDomainSettings", response);
    //         vm.be_Id = response[1][0].MBEDomainId;
    //         console.log("vm.be_Id===>", vm.be_Id);

    //         vm.Get_BookingEngine_Config();
    //         vm.$store.dispatch("toastr", {
    //           type: "success",
    //           header: "Success!",
    //           message: "successfully Saved"
    //         });
    //         return;
    //       } else if (
    //         response[0] &&
    //         response[0][0] &&
    //         response[0][0].ErrorMessage &&
    //         response[0][0].ErrorMessage != ""
    //       ) {
    //         vm.$store.dispatch("toastr", {
    //           type: "error",
    //           header: "Error!",
    //           message: response[0][0].ErrorMessage
    //         });
    //         return;
    //       }
    //     }
    //   });

    // },
    saveHeaderConfiguration() {
      let vm = this;
      vm.headerPreview = `<html><head><style>${vm.beData.HeaderStyle}</style></head><body>${vm.beData.HeaderText}</body></html>`;
    },
    saveAsideLeftConfiguration() {
      let vm = this;
      vm.leftPreview = `<html><head><style>${vm.beData.LeftViewStyle}</style></head><body>${vm.beData.LeftViewText}</body></html>`;
    },
    saveAsideRightConfiguration() {
      let vm = this;
      vm.rightPreview = `<html><head><style>${vm.beData.RightViewStyle}</style></head><body>${vm.beData.RightViewText}</body></html>`;
    },
    saveFooterConfiguration() {
      let vm = this;
      vm.footerPreview = `<html><head><style>${vm.beData.FooterStyle}</style></head><body>${vm.beData.FooterText}</body></html>`;
    },
    saveCss() {
      let vm = this;
    },
    saveTermsAndConditions() {
      let vm = this;
      console.log("saveTermsAndConditions", vm.beData.TermsAndConditions);
    },
    showCssMasterPanel() {
      let vm = this;
      vm.cssMaterPanel = true;
      vm.csspanel = false;
    },
    showCssPanel() {
      let vm = this;
      vm.cssMaterPanel = false;
      vm.csspanel = true;
    },
    Get_BookingEngine_Config() {
      let vm = this;
      if (vm.$route.params.beId != -1) {
        vm.showDomainConfiguration = false;
        vm.showHeaderConfiguration = false;
        vm.showFooterConfiguration = false;
        vm.showTermsAndConditionsConfiguration = false;
        vm.showAsideLeftConfiguration = false;
        vm.showAsideRightConfiguration = false;
        // vm.showmapConfiguration = false;
        // vm.showCssMaster = false;
      }
      vm.$store.dispatch("dataRequestHandler", {
        key: "Get_BookingEngine_Config",
        params: {
          ModuleAction: "Get_BookingEngine_Config",
          BE_Id: vm.$route.params.beId
        },
        callback: function(err, response) {
          if (err) {
            console.log("Error in Get_BookingEngine_Config => ", err);
            return;
          }
          if (response) {
            console.log("response in Get_BookingEngine_Config", response);

            vm.tldList = response[0];
            vm.beData.IsHostMode = response[1] && response[1][0] ? response[1][0].IsHostMode : 1
            if (response[1] && response[1][0] && response[1][0].BE_Id) {
              vm.beData = response[1][0];
              if (vm.beData.Defaultsortorder == undefined) {
                vm.beData.Defaultsortorder = "-99";
              }
              if (vm.beData.DefaultLocationName == undefined) {
                vm.beData.DefaultLocationName = "-99";
              } 
              if (vm.beData.Defaultnoofadults == undefined) {
                vm.beData.Defaultnoofadults = 2;
              } 
              if (vm.beData.Defaultnoofchildren == undefined) {
                vm.beData.Defaultnoofchildren = 0;
              } 

              vm.isCheckedleftConfig = vm.beData.LeftPanelVisibility;
              vm.isCheckedrightConfig = vm.beData.RightPanelVisibility;
              if (vm.isCheckedleftConfig == true) {
                vm.showleftConfig = false;
              }
              if (vm.isCheckedrightConfig == true) {
                vm.showrightConfig = false;
              }

              if (
                vm.beData.HeaderHeightStyle &&
                (vm.beData.HeaderHeightStyle != null ||
                  vm.beData.HeaderHeightStyle != "") &&
                vm.beData.HeaderHeightStyle == "Auto"
              ) {
                vm.disableHeaderInput = true;
              }
              if (
                vm.beData.FooterHeightStyle &&
                (vm.beData.FooterHeightStyle != null ||
                  vm.beData.FooterHeightStyle != "") &&
                vm.beData.FooterHeightStyle == "Auto"
              ) {
                vm.disableFooterInput = true;
              }

              // vm.beId = response[1][0].BE_Id;

              if (
                vm.beData.HeaderText == null ||
                vm.beData.HeaderText == "" ||
                vm.beData.HeaderText == undefined ||
                vm.beData.HeaderText == " "
              ) {
                vm.beData.HeaderTex = "";
                vm.showHeaderConfiguration = true;
              }
              if (
                vm.beData.FooterText == null ||
                vm.beData.FooterText == "" ||
                vm.beData.FooterText == undefined ||
                vm.beData.FooterText == " "
              ) {
                vm.beData.FooterText = "";
                vm.showFooterConfiguration = true;
              }
              if (
                vm.beData.TermsAndConditions == null ||
                vm.beData.TermsAndConditions == "" ||
                vm.beData.TermsAndConditions == undefined ||
                vm.beData.TermsAndConditions == " "
              ) {
                vm.beData.TermsAndConditions = "";
                vm.showTermsAndConditionsConfiguration = true;
              }

              if (
                vm.beData.LeftViewText == null ||
                vm.beData.LeftViewText == "" ||
                vm.beData.LeftViewText == undefined ||
                vm.beData.LeftViewText == " "
              ) {
                vm.beData.LeftViewText = "";
                vm.showAsideLeftConfiguration = true;
              }
              if (
                vm.beData.RightViewText == null ||
                vm.beData.RightViewText == "" ||
                vm.beData.RightViewText == undefined ||
                vm.beData.RightViewText == " "
              ) {
                vm.beData.RightViewText = "";
                vm.showAsideRightConfiguration = true;
              }

              vm.headerPreview = `<html><head><style>${vm.beData.HeaderStyle}</style></head><body>${vm.beData.HeaderText}</body></html>`;
              vm.footerPreview = `<html><head><style>${vm.beData.FooterStyle}</style></head><body>${vm.beData.FooterText}</body></html>`;
              vm.leftPreview = `<html><head><style>${vm.beData.LeftViewCSS}</style></head><body>${vm.beData.LeftViewText}</body></html>`;
              vm.rightPreview = `<html><head><style>${vm.beData.RightViewCSS}</style></head><body>${vm.beData.RightViewText}</body></html>`;
              console.log("vm.beData", vm.beData);
            }
            if (response[5] && response[5].length) {
              vm.latLogList = response[5];
              vm.addMarker();
            }
            if (response[4] && response[4].length) {
              vm.resStatusDropdown = response[4];
            }
            if (response[6] && response[6].length) {
              vm.AminitiesData = response[6];
            }
            if (response[7] && response[7].length) {
              vm.locationList = response[7];
            }
            if (response[8] && response[8].length && response[8][0].UnitId && response[8][0].UnitId == -1) {
              vm.unitToggle = true;
              if (vm.beData.IsHostMode != 1) {
                vm.unitLabel.UnitTypeName = "All Unit Types";
              } else {
                vm.unitLabel.UnitNickName = "All Units";
              }
            } else if (response[8] && response[8].length == 0) {
              vm.unitToggle = true;
              if (vm.beData.IsHostMode != 1) {
                vm.unitLabel.UnitTypeName = "All Unit Types";
              } else {
                vm.unitLabel.UnitNickName = "All Units";
              }
            } else {
              vm.unitToggle = false;
              if (vm.beData.IsHostMode != 1) {
                vm.unitLabel.UnitTypeName = "All Unit Types";
                vm.filteredUnitTypeList = response[8];
              } else {
                vm.unitLabel.UnitNickName = "All Units";
                vm.filteredUnitList = response[8];
              }
            }
            if (response[9] && response[9].length && response[9][0].PropertyId && response[9][0].PropertyId == -1) {
              vm.propertyToggle = true;
              vm.propertyLabel = response[9][0];
            } else if (response && response[9] && response[9].length == 0) {
              vm.propertyToggle = true;
              vm.propertyLabel.PropertyName = "All Properties"
            } else {
              vm.propertyToggle = false;
              vm.filteredPropertyList = response[9];
            }
            if (response[10] && response[10].length) {
              vm.sortOrderList = response[10];
            }


            // if (response[9] && response[9].length > 0) {
            //   vm.filteredUnitList = response.recordsets[9];
            // }
            // if (response[10] && response[10].length > 0) {
            //   vm.filteredPropertyList = response.recordsets[10];
            // }
            // vm.getImages();
          }
        }
      });
    },
    addMarker() {
      let vm = this;
      if (parseInt(vm.beData.MinZoomValue) > parseInt(vm.beData.MaxZoomValue)) {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning!",
          message: "Min zoom value should not exceed max zoom value"
        });
        return;
      }
      vm.$store.state.bus.$emit("add-marker", {
        latitudeLongitude: vm.latLogList,
        MaxZoomValue: vm.beData.MaxZoomValue,
        MinZoomValue: vm.beData.MinZoomValue
      });
    },

    Save_BEDomainSettings(StatusId, name) {
      let vm = this;
      this.$validator.validateAll().then(result => {

        if(result){
          // console.log("vm.beData.Headername", vm.selectedValue);
          if (vm.displaySectionValue == "DomainConfiguration") {
            if (!vm.beData.TLD_Id) {
              vm.$store.dispatch("toastr", {
                type: "warning",
                header: "Warning!",
                message: "Please select TLD"
              });
              return;
            } else if (!vm.beData.SubDomainName) {
              vm.$store.dispatch("toastr", {
                type: "warning",
                header: "Warning!",
                message: "Please enter sub domain name"
              });
              return;
            }
            // else if ((vm.beData.GuestPattern == "Persons" && (vm.beData.DefaultnoofGuests == null || !vm.beData.DefaultnoofGuests))||(vm.beData.GuestPattern != "Persons" && (vm.beData.Defaultnoofadults == null || !vm.beData.Defaultnoofadults || vm.beData.Defaultnoofchildren == null || !vm.beData.Defaultnoofchildren))){
            //   vm.$store.dispatch("toastr", {
            //     type: "warning",
            //     header: "Warning!",
            //     message: "No of guest/adults/children can't be empty"
            //   });
            // return;
            // }
          }
          if (
            vm.displaySectionValue != "DomainConfiguration" &&
            vm.$route.params.beId == -1
          ) {
            vm.$store.dispatch("toastr", {
              type: "warning",
              header: "Warning!",
              message: "Please save DomainConfiguration"
            });
            return;
          }
          vm.checkedAminities.splice(0);
          if (vm.AminitiesData && vm.AminitiesData.length > 0) {
            for (let aminity of vm.AminitiesData) {
              if (Number(aminity["IsChecked"])) {
                console.log("ami name ====>>", aminity.ListName);
                vm.checkedAminities.push(aminity["AmenityId"]);
              }
            }
          }

          let unitIds = []
          if (vm.beData.IsHostMode == 1) {
            unitIds = vm.filteredUnitList.map(x => x.UnitId)
          } else {
            unitIds = vm.filteredUnitTypeList.map(x => x.UnitTypeId || x.UnitId)
          }

          let propertyIds = vm.filteredPropertyList.map(x => x.PropertyId)

          vm.$store.dispatch("dataRequestHandler", {
            key: "Save_BEDomainSettings",
            params: {
              ModuleAction: "Save_BEDomainSettings",
              BE_Id: vm.$route.params.beId,
              BE_Name: vm.beData.BE_Name,
              BE_Description: vm.beData.BE_Description,
              GACode: vm.beData.GACode,
              // DepositPercent: vm.beData.DepositPercent,
              GuestPattern: vm.beData.GuestPattern,
              ChargesPattern: vm.beData.ChargesPattern,
              AccomodationPattern: vm.beData.AccomodationPattern,
              TLD_Id: vm.beData.TLD_Id,
              SubDomainName: vm.beData.SubDomainName,
              StatusId: StatusId,
              IsCheckedleftConfig: vm.isCheckedleftConfig,
              IsCheckedrightConfig: vm.isCheckedrightConfig,
              sectionName: name,
              BE_Type: vm.beData.BE_Type,
              Header: vm.beData.HeaderText,
              Footer: vm.beData.FooterText,
              LeftView: vm.beData.LeftViewText,
              RightView: vm.beData.RightViewText,
              HeaderStyle: vm.beData.HeaderStyle,
              HeaderHeight: vm.beData.HeaderHeight,
              FooterHeight: vm.beData.FooterHeight,
              BeCss: vm.beData.BEcss,
              HeaderHeightStyle: vm.beData.HeaderHeightStyle,
              FooterHeightStyle: vm.beData.FooterHeightStyle,
              ResStatusId: vm.beData.ResStatusId,
              FooterStyle: vm.beData.FooterStyle,
              LeftViewCSS: vm.beData.LeftViewCSS,
              RightViewCSS: vm.beData.RightViewCSS,
              MaxZoomValue: vm.beData.MaxZoomValue,
              MinZoomValue: vm.beData.MinZoomValue,
              TermsAndConditions: vm.beData.TermsAndConditions,
              checkedAminities: vm.checkedAminities,
              searchByUnits: vm.beData.ByUnits,
              Location: vm.beData.DefaultLocationName,
              NumberOfGuests: vm.beData.DefaultnoofGuests,
              NumberOfAdults: vm.beData.Defaultnoofadults,
              NumberOfChildren: vm.beData.Defaultnoofchildren,
              Cancellationpolicyurl: vm.beData.Cancellationpolicyurl,
              PropertyIds: propertyIds ? propertyIds.join() : -1,
              UnitIds: unitIds.join(),
              SortOrder: vm.beData.Defaultsortorder
            },

            callback: function(err, response) {
              //   vm.showDomainConfiguration = false;
              // vm.showHeaderConfiguration = false;
              // vm.showFooterConfiguration = false;
              // vm.showAsideLeftConfiguration = false;
              // vm.showAsideRightConfiguration = false;
              if (err) {
                console.log("Error in Save_BEDomainSettings => ", err);
                vm.$store.dispatch("toastr", {
                  type: "error",
                  header: "Error!",
                  message: "Error while saving DomainConfiguration"
                });
                return;
              }

              if (response) {
                console.log("response in Save_BEDomainSettings", response);
                // vm.$route.params.beId = response[1][0].MBEDomainId;
                vm.$router.push(
                  "/bookingEngineDetail/" + response[1][0].MBEDomainId
                );
                let list = vm.tldList.filter(x => x.TLD_Id == vm.beData.TLD_Id);
                vm.beData.TLD_Name = list[0].TLD_Name;
                console.log("vm.beData.TLD_Name===>", list[0].TLD_Name);
                vm.showDomainConfiguration = false;

                console.log(" vm.$route.params.beId", vm.$route.params.beId);
                if (response[1][0].Sectionname == "DomainConfiguration") {
                  if (response[1][0].StatusId == 2) {
                    vm.$store.dispatch("toastr", {
                      type: "success",
                      header: "Success!",
                      message: " DomainConfiguration successfully deleted"
                    });
                    vm.$router.push("/integrationPage");
                  } else {
                    vm.Get_BookingEngine_Config()
                    vm.$store.dispatch("toastr", {
                      type: "success",
                      header: "Success!",
                      message: " DomainConfiguration successfully Saved"
                    });
                  }
                }
                if (response[1][0].Sectionname == "HeaderConfiguration") {
                  vm.showHeaderConfiguration = false;
                  vm.Get_BookingEngine_Config();
                  vm.$store.dispatch("toastr", {
                    type: "success",
                    header: "Success!",
                    message: " HeaderConfiguration successfully Saved"
                  });
                }

                if (response[1][0].Sectionname == "AsideLeftConfiguration") {
                  vm.showAsideLeftConfiguration = false;
                  vm.Get_BookingEngine_Config();
                  vm.$store.dispatch("toastr", {
                    type: "success",
                    header: "Success!",
                    message: " AsideLeftConfiguration successfully Saved"
                  });
                }
                if (response[1][0].Sectionname == "AsideRightConfiguration") {
                  vm.showAsideRightConfiguration = false;
                  vm.Get_BookingEngine_Config();
                  vm.$store.dispatch("toastr", {
                    type: "success",
                    header: "Success!",
                    message: " AsideRightConfiguration successfully Saved"
                  });
                }
                if (response[1][0].Sectionname == "FooterConfiguration") {
                  vm.showFooterConfiguration = false;
                  vm.Get_BookingEngine_Config();

                  vm.$store.dispatch("toastr", {
                    type: "success",
                    header: "Success!",
                    message: " FooterConfiguration successfully Saved"
                  });
                }
                if (response[1][0].Sectionname == "CssMaster") {
                  vm.$store.dispatch("toastr", {
                    type: "success",
                    header: "Success!",
                    message: " CssMaster successfully Saved"
                  });
                }
                if (response[1][0].Sectionname == "TermsAndConditions") {
                  vm.showTermsAndConditionsConfiguration = false;
                  vm.Get_BookingEngine_Config();
                  vm.$store.dispatch("toastr", {
                    type: "success",
                    header: "Success!",
                    message: " TermsAndConditions successfully Saved"
                  });
                }
                if (response[1][0].Sectionname == "Maps") {
                  vm.$store.dispatch("toastr", {
                    type: "success",
                    header: "Success!",
                    message: " Maps successfully Saved"
                  });
                }
                if (response[1][0].Sectionname == "Amenities") {
                  vm.$store.dispatch("toastr", {
                    type: "success",
                    header: "Success!",
                    message: " Amenities successfully Saved"
                  });
                  vm.Get_BookingEngine_Config();
                }

                return;
              } else if (
                response[0] &&
                response[0][0] &&
                response[0][0].ErrorMessage &&
                response[0][0].ErrorMessage != ""
              ) {
                vm.$store.dispatch("toastr", {
                  type: "error",
                  header: "Error!",
                  message: response[0][0].ErrorMessage
                });
                return;
              }
            }
          });
        }
      })
    }
    // getGoogleAnalyticsReport() {
    //   let vm = this;
    //   console.log("here");
    //   vm.showGraph = false;
    //   let startDate ="", endDate ="";
    //   if( vm.StartDate == "" || vm.StartDate == null){
    //     startDate = "30daysAgo"
    //   }
    //   else{
    //     startDate = vm.StartDate
    //   }
    //   if(vm.EndDate == "" || vm.EndDate == null){
    //     endDate = "today"
    //   }
    //   else{
    //     endDate = vm.EndDate
    //   }
    //   let metrics = "ga:users, ga:pageviews, ga:sessions";
    //   vm.$store.dispatch("dataRequestHandler", {
    //     key: "googleAnalyticsReports",
    //     params: {
    //       startDate: startDate,
    //       endDate: endDate,
    //       // metrics: 'ga:sessions'
    //       metrics: metrics
    //     },
    //     callback: function (err, response) {
    //       if (err) {
    //         console.log("Error has occured => ", err);

    //       }
    //       if (response) {
    //         console.log("response in getGoogleAnalyticsReport", response);
    //         // for(){
    //         //   str.substring(1, 4)
    //         // }
    //         vm.showGraph = true;
    //         vm.series = [];
    //         vm.chartOptions.xaxis.categories = [];
    //         vm.series.push({
    //             data: [],
    //             name: ""
    //           },
    //           {
    //             data: [],
    //             name: ""
    //           },
    //           {
    //             data: [],
    //             name: ""
    //           });
    //         for (var i = 0; i < response.rows.length; i++) {

    //           // console.log("vm.series[0]", vm.series[0])
    //           vm.series[0].data.push(response.rows[i][1]);
    //           vm.series[1].data.push(response.rows[i][2]);
    //           vm.series[2].data.push(response.rows[i][3]);
    //           vm.series[0].name = "Users";
    //           vm.series[1].name = "Page Views";
    //           vm.series[2].name = "Sessions";
    //           vm.chartOptions.xaxis.categories.push(vm.formatToDate(response.rows[i][0]))
    //         }
    //         vm.items = response.rows;
    //       }
    //     }
    //   });
    // },
    // formatToDate(str) {
    //   var year = str.substring(0, 4);
    //   var month = str.substring(4, 6);
    //   var date = str.substring(6, 8);

    //   return year + "-" + month + "-" + date;
    // },
  },
  watch: {
    filterSearchPropertyNameText(searchText) {
      this.getPropertiesBySearchText(searchText)
    },
    filterSearchUnitTypeNameText(searchText) {
      this.getUnitTypeList(searchText);
    },
    filterSearchUnitNameText(searchText) {
      this.getUnitNamesBySearchText(searchText);
    },
    propertyToggle(value) {
      let vm = this;
      if (value == true) {
        vm.filteredPropertyList = [];
        vm.propertyLabel.PropertyName = "All Properties";
      }
    },
    unitToggle(value) {
      let vm = this;
      if (value == true) {
        vm.filteredUnitTypeList = [];
        vm.filteredUnitList = [];
        if (vm.beData.IsHostMode != 1) {
          vm.unitLabel.UnitTypeName = "All Unit Types";
        }
        else {
          vm.unitLabel.UnitNickName = "All Units";

        }
      }
    }
    // selectedValue: function (val) {
    //   let vm = this;
    //   console.log("selectedValue-value", val);
    //   if (val == "Auto") {
    //     vm.disableHeaderInput = true;
    //   }
    // }
  },
  computed: {},

  mounted() {
    let vm = this;
    // vm.Get_BotDetails();
    $(document).click(function (e) {
      console.log("clicked on doc");
      $("#propertyDropdownlist").hide();
      $("#unitTypeDropdownlist").hide();
      $("#unitDropdownlist").hide();
    });
    // vm.GetPropertyAndUnitList_BE();
    vm.Get_BookingEngine_Config();
    vm.getImages();
    // vm.getGoogleAnalyticsReport();
  }
};
</script>